import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import folder from 'src/assets/custom-icons/folder.svg'

export function mimetypeToIcon(mimeType:string) {
    switch (mimeType) {
        case 'video/mp4':                                                   
        return <FontAwesomeIcon icon={["fas", "video"]} className='w-4 h-4'/>

        case 'application/zip':                                             
        return <FontAwesomeIcon icon={["fas", "file-zipper"]} className='w-4 h-4'/>

        case 'image/png': case 'image/jpeg': case 'image/gif':              
        return <FontAwesomeIcon icon={["fas", "image"]} className='w-4 h-4'/>

        case 'text/html':                                                  
        return <FontAwesomeIcon icon={["fab", "html5"]} className='w-4 h-4'/>

        case 'image/svg+xml': case 'application/postscript':                
        return <FontAwesomeIcon icon={["fas", "bezier-curve"]} className='w-4 h-4'/>

        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': case 'application/vnd.ms-excel': 
        return <FontAwesomeIcon icon={["fas", "file-excel"]} className='w-4 h-4'/>

        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        return <FontAwesomeIcon icon={["fas", "file-powerpoint"]} className='w-4 h-4'/>  

        case 'application/json': case 'application/xml':                    
        return <FontAwesomeIcon icon={["fas", "file-code"]} className='w-4 h-4'/>

        case 'text/plain':                                                  
        return <FontAwesomeIcon icon={["fas", "file-lines"]} className='w-4 h-4'/>

        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return <FontAwesomeIcon icon={["fas", "file-word"]} className='w-4 h-4'/>

        case 'application/octet-stream':                                    
        return <FontAwesomeIcon icon={["fas", "file"]} className='w-4 h-4'/>

        case 'application/pdf':
        return <FontAwesomeIcon icon={["fas", "file-pdf"]} className='w-4 h-4'/>    
    
        case 'folder':
        return <img src={folder} alt="folder" className='w-4 h-4 min-w-4'/>

        default:                                                           
        return <FontAwesomeIcon icon={["fas", "file"]} className='w-4 h-4'/>     
    }
}